import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import EmailConfirm from "@/pages/EmailConfirm";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Tasks from "@/pages/Tasks";
import TaskDetail from "@/pages/TaskDetail";
import Issues from "@/pages/Issues";
import IssueDetail from "@/pages/IssueDetail";
import Payments from "@/pages/Payments";
import Users from "@/pages/Users";
import UserDetail from "@/pages/UserDetail";
import Score from "@/pages/Score";
import TesterScores from "@/pages/TesterScores";
import Profile from "@/pages/Profile";
import MyProjects from "@/pages/MyProjects";
import Security from "@/pages/Security";
import Audit from "@/pages/Audit";
import TaskReport from "@/pages/TaskReport";
import TaskGroup from "@/pages/TaskGroup";
import SharedReport from "@/pages/SharedReport";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center text-slate-500">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/confirm-email" element={<EmailConfirm />} />

          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/projects" element={<Protected><Projects /></Protected>} />
          <Route path="/projects/:id" element={<Protected><ProjectDetail /></Protected>} />
          <Route path="/tasks" element={<Protected><Tasks /></Protected>} />
          <Route path="/tasks/:id" element={<Protected><TaskDetail /></Protected>} />
          <Route path="/tasks/:id/report" element={<Protected><TaskReport /></Protected>} />
          <Route path="/task-groups/:gid" element={<Protected roles={["admin","manager"]}><TaskGroup /></Protected>} />
          <Route path="/shared/report/:token" element={<SharedReport />} />
          <Route path="/issues" element={<Protected><Issues /></Protected>} />
          <Route path="/issues/:id" element={<Protected><IssueDetail /></Protected>} />
          <Route path="/payments" element={<Protected roles={["admin","manager","freelancer"]}><Payments /></Protected>} />
          <Route path="/users" element={<Protected roles={["admin","manager"]}><Users /></Protected>} />
          <Route path="/users/:id" element={<Protected><UserDetail /></Protected>} />
          <Route path="/score" element={<Protected roles={["freelancer"]}><Score /></Protected>} />
          <Route path="/tester-scores" element={<Protected roles={["admin","manager"]}><TesterScores /></Protected>} />
          <Route path="/profile" element={<Protected><Profile /></Protected>} />
          <Route path="/my-projects" element={<Protected roles={["freelancer"]}><MyProjects /></Protected>} />
          <Route path="/security" element={<Protected><Security /></Protected>} />
          <Route path="/audit" element={<Protected roles={["admin"]}><Audit /></Protected>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
